// extracted by mini-css-extract-plugin
export default {"Icon":"Icon_Icon__PHW5s"};